import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import PythonOutlinedSvg from "@ant-design/icons-svg/es/asn/PythonOutlined";
import AntdIcon from "../components/AntdIcon";
var PythonOutlined = function PythonOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: PythonOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  PythonOutlined.displayName = 'PythonOutlined';
}
export default /*#__PURE__*/React.forwardRef(PythonOutlined);